/**
* reducers for the notifications
*
* Created by Heesien on 20/08/18
*/

import C from '../constants'

const initState = {
    congratulate_message: null,
    news_items: [],
    pending_actions: [],
    isLoading: false,
}

export const notificationsState = (state = initState, action) => {

    switch(action.type) {

        case C.SET_NOTIFICATIONS_LOADER:
            return {
                ...state,
                isLoading: action.payload
            }

        case C.SET_NOTIFICATIONS_DATA:
            return {
                ...state,
                ...action.payload
            }

        case C.REMOVE_NOTIFICATIONS_PENDING_ACTION:
            return {
                ...state,
                pending_actions: state.pending_actions.filter(item => item.id !== action.payload)
            }

        default: return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/notificationsReducer.js